// Import formulaire CEE (Phase 1) — mapping clé extraction → (section, champ) de
// l'état OMV {entreprise,representant,batiment,technique,cee}. Source unique
// partagée par CreateDossier (monde dossiers) et OmvCeeEditor (formulaire
// prospect, dont la régie). L'entreprise est exclue (remplie par SIREN via
// siret_detecte), la réf formulaire Vision est rangée à part dans
// cee.reference_formulaire (jamais dans numero_dossier). `bool` = booléen,
// sinon stocké en string (inputs OMV).
export const CEE_IMPORT_MAP = [
  ["representant_nom", "representant", "nom", "Nom représentant"],
  ["representant_prenom", "representant", "prenom", "Prénom représentant"],
  ["representant_fonction", "representant", "fonction", "Fonction"],
  ["representant_email", "representant", "email", "Email"],
  ["representant_tel", "representant", "tel", "Téléphone"],
  ["representant_portable", "representant", "portable", "Portable"],
  ["batiment_nom_etablissement", "batiment", "nom_etablissement", "Nom du site"],
  ["batiment_type", "batiment", "type_batiment", "Type bâtiment"],
  ["batiment_plus_2_ans", "batiment", "plus_2_ans", "Bâtiment > 2 ans", true],
  ["batiment_surface_ventilee_m2", "batiment", "surface_ventilee_m2", "Surface ventilée (m²)"],
  ["batiment_nb_logements", "batiment", "nb_logements", "Nb logements"],
  ["batiment_adresse_travaux", "batiment", "adresse_travaux", "Adresse travaux"],
  ["batiment_cp_travaux", "batiment", "cp_travaux", "CP travaux"],
  ["batiment_ville_travaux", "batiment", "ville_travaux", "Ville travaux"],
  ["technique_type_vmc", "technique", "type_vmc", "Type VMC"],
  ["technique_nb_caissons", "technique", "nb_caissons", "Nb caissons"],
  ["operation_code_fiche", "cee", "code_fiche", "Code fiche CEE"],
  ["operation_libelle", "cee", "operation_cee", "Opération CEE"],
  ["operation_montant_prime_cee", "cee", "montant_prime_cee", "Montant prime CEE"],
  ["operation_delegataire_nom", "cee", "delegataire_nom", "Délégataire"],
];
